/****************************************************
 * Module Name:  addIssue.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import Constants from "../../utility/constants";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, Tooltip } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import DepartmentProxy from "../../utility/proxy/manager/manufacturingProxy/departmentProxy";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";
import UserProcessMasterProxy from "../../utility/proxy/manager/manufacturingProxy/userProcessMasterProxy";

export default class AddIssue extends Component {
    constructor(props) {
        super(props);

        this.state = {
            responseData: [],
            newDepartmentGroup: "",
            departmentGroupOptions: [],
            newDepartmentHead: "",
            departmentHeadOptions: [],
            newDepartment: "",
            departmentOptions: [],
            newProcess: "",
            processOptions: [],
            processOptionMap: new Map(),
            showError: false,

            showDepartmentGroupLoadSpinner: true,
            showIssueUsersLoadSpinner: true,

            issueValidationError: "",
            showUserDetailModal: false,
        };
        this.getAllDepartmentData(true);
        this.getAllProcessData();
    }

    getAllDepartmentData = (bAnimateSpinner) => {
        bAnimateSpinner && this.setState({ showDepartmentGroupLoadSpinner: true });
        DepartmentProxy.GetAllDepartmentDetailMini((response) =>
            this.setAllDepartmentData(response)
        );
    };

    getAllProcessData = () => {
        UserProcessMasterProxy.GetAllUserProcess((response) =>
            this.setAllProcessData(response)
        );
    };

    setAllProcessData = (response) => {
        const processMap = new Map();
        response.forEach(user => {
            if (user.userid && Array.isArray(user.assignedprocess)) {
                processMap.set(user.userid, user.assignedprocess);
            }
        });
        this.setState({
            processOptionMap: processMap,
        });
    };

    setAllDepartmentData = (response) => {
        let deptGroupOptions = [];
        let deptOptions = [];

        deptGroupOptions.push({ value: "*", label: "-- ANY --" });

        response.map((data) => {
            let groupOption = {
                value: data.departmentGroupId,
                label: data.departmentGroupId + " | " + data.departmentGroupName,
            };
            let deptOption = {
                value: data.departmentId,
                label: data.departmentId + " | " + data.departmentName,
            };
            deptGroupOptions.push(groupOption);
            deptOptions.push(deptOption);
            return true;
        });

        const key = "value";

        const arrayUniqueByKey = [
            ...new Map(deptGroupOptions.map((item) => [item[key], item])).values(),
        ];

        this.setState({
            responseData: response,
            departmentGroupOptions: arrayUniqueByKey,
            departmentOptions: deptOptions,
            newDepartmentGroup:
                this.state.newDepartmentGroup === "" && arrayUniqueByKey.length > 0
                    ? arrayUniqueByKey[0]
                    : this.state.newDepartmentGroup,
            showDepartmentGroupLoadSpinner: false,
        });
    };

    handleDeptGroupChange = (selectedOption) => {
        // filtering out the department that the loggeed in user is already part of bec it cant issue to the same department
        let deptId = new Set(this.props.sourceData.map(iData => iData.department_id));
        if (selectedOption.value === "*") {
            let deptOptionsforAny = [];
            this.state.responseData
                .filter(iData => !deptId.has(iData.departmentId))
                .map((data) => {
                    let deptOption = {
                        value: data.departmentId,
                        label: data.departmentId + " | " + data.departmentName,
                    };
                    deptOptionsforAny.push(deptOption);
                    return true;
                });
            this.setState({
                departmentOptions: deptOptionsforAny,
                newDepartmentGroup: selectedOption,
                newDepartment: "",
                newDepartmentHead: ""
            });
            return;
        }

        let selectedValue = selectedOption.value;

        let deptOptions = [];

        this.state.responseData
            .filter(iData => !deptId.has(iData.departmentId))
            .map((data) => {
                if (data.departmentGroupId === selectedValue) {
                    let deptOption = {
                        value: data.departmentId,
                        label: data.departmentId + " | " + data.departmentName,
                    };
                    deptOptions.push(deptOption);
                }
                return true;
            });
        this.setState({
            departmentOptions: deptOptions,
            newDepartmentGroup: selectedOption,
            newDepartment: "",
            newDepartmentHead: ""
        });
    };

    handleDeptChange = (selectedOption) => {
        let selectedValue = selectedOption.value;

        let deptHeadOptions = [];
        let deptGroupOption = {};

        this.state.responseData.map((data) => {
            if (data.departmentId === selectedValue) {
                deptGroupOption = {
                    value: data.departmentGroupId,
                    label: data.departmentGroupId + " | " + data.departmentGroupName,
                };
                data.heads.map((head) => {
                    let deptHeadOption = {
                        value: head.userid,
                        label: head.userid + " | " + head.username,
                    };
                    deptHeadOptions.push(deptHeadOption);
                    return true;
                });
            }
            return true;
        });
        this.setState({
            departmentHeadOptions: deptHeadOptions,
            newDepartment: selectedOption,
            newDepartmentHead: ""
        });
        if (this.state.newDepartmentGroup.value === "*")
            this.setState({ newDepartmentGroup: deptGroupOption });
    };

    handleDeptHeadChange = (selectedOption) => {
        let processOptions = [];
        this.state.processOptionMap.forEach((value, key) => {
            if (key === selectedOption.value) {
                value.forEach(process => {
                    let processOption = {
                        value: process.id,
                        label: process.name,
                    };
                    processOptions.push(processOption);
                });
            }
        });
        let nextProcess = this.props.sourceData[0].nextprocessid ? processOptions.find(proc => proc.value === this.props.sourceData[0].nextprocessid) : null;
        let process = nextProcess !== null ? nextProcess : processOptions.length > 0 ? processOptions[0] : "";
        this.setState({ newDepartmentHead: selectedOption, processOptions: processOptions, newProcess: process });
    };

    prepareData = () => {
        let arr = []
        this.props.sourceData.map((item) => {
            let obj = {}
            obj.kapanid = item.kapanid
            obj.packetid = item.packetid
            arr.push(obj)
            return true;
        })

        return arr;
    }

    handleSave = () => {
        let data = {
            userid: Constants.loggedInUser.id,
            departmentid: this.state.newDepartment.value,
            departmentgroupid: this.state.newDepartmentGroup.value,
            headid: this.state.newDepartmentHead.value,
            date: new Date().toISOString(),
            processid: this.state.newProcess != null ? this.state.newProcess.value : null,
            kapanspacket: this.prepareData()
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data)) this.props.handleSave(data);
                else
                    this.setState({
                        showError: true,
                    });
            } else this.props.handleSave(data);
        }
    };

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    buttonDisable = () => {
        return (
            this.state.newDepartmentHead.length === 0 ||
            this.state.newDepartmentGroup.length === 0 ||
            this.state.newDepartment.length === 0
        );
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        this.props.reIssue ?
                            <Box>
                                Re-issue validation Failed
                                <br /> Please enter complete data
                            </Box> :
                            <Box>
                                Add issue validation Failed
                                <br /> Please enter complete data
                            </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />

                {this.state.showUserDetailModal ? (
                    <UserDetailModal
                        show={true}
                        handleClose={() => this.setState({ showUserDetailModal: false })}
                        handleSelect={(selectedOption) => {
                            const selectedCustomers = this.state.departmentHeadOptions.filter(opt =>
                                selectedOption.includes(opt.value)
                            );
                            this.setState({
                                newDepartmentHead: selectedCustomers[0],
                                showUserDetailModal: false
                            });
                        }}
                        userids={this.state.departmentHeadOptions.map(cust => cust.value)}
                        selectedIds={this.state.newDepartmentHead.length !== 0 ? this.state.newDepartmentHead.value : []}
                        usertype={"U"}
                        loading={this.state.showUserDetailModal}
                        isMulti={false}
                    />
                ) : null}

                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            {this.props.editOperation || this.props.sourceData === undefined || this.props.PacketId
                                ? "Re-Issue"
                                : "Add New Issue"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Form.Label>Department Group</Form.Label>
                                        </td>
                                        <td style={{ width: "70%" }}>
                                            <Select menuPlacement="auto"
                                                blurInputOnSelect={false}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                value={this.state.newDepartmentGroup}
                                                isSearchable={true}
                                                name="Department Group"
                                                styles={Constants.Styles}
                                                menuPortalTarget={document.body}
                                                options={this.state.departmentGroupOptions}
                                                onChange={(selectedOption) =>
                                                    this.handleDeptGroupChange(selectedOption)
                                                }
                                            />
                                        </td>
                                        <td>
                                            {this.state.showDepartmentGroupLoadSpinner ? (
                                                <CircularProgress
                                                    size="1em"
                                                    sx={{ mt: 1.5, ml: 0.7 }}
                                                />
                                            ) : (
                                                <Tooltip title="Reload">
                                                    <RefreshOutlinedIcon
                                                        color="primary"
                                                        fontSize="medium"
                                                        onClick={() => this.getAllDepartmentData(true)}
                                                        sx={{
                                                            cursor: "pointer",
                                                            mt: 1,
                                                        }}
                                                    />
                                                </Tooltip>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Department</Form.Label>
                                        </td>
                                        <td style={{ width: "70%" }}>
                                            <Box maxHeight={350}>
                                                <Select menuPlacement="auto"
                                                    blurInputOnSelect={false}
                                                    value={this.state.newDepartment}
                                                    isSearchable={true}
                                                    name="Department"
                                                    styles={Constants.Styles}
                                                    menuPortalTarget={document.body}
                                                    options={this.state.departmentOptions}
                                                    onChange={(selectedOption) =>
                                                        this.handleDeptChange(selectedOption)
                                                    }
                                                />
                                            </Box>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Department Head</Form.Label>
                                        </td>
                                        <td style={{ width: "70%" }}>
                                            <Select
                                                menuPlacement="auto"
                                                blurInputOnSelect={false}
                                                value={this.state.newDepartmentHead}
                                                isSearchable={true}
                                                name="Department Head"
                                                styles={Constants.Styles}
                                                menuPortalTarget={document.body}
                                                options={this.state.departmentHeadOptions}
                                                onChange={(selectedOption) =>
                                                    this.handleDeptHeadChange(selectedOption)
                                                }
                                            />
                                        </td>
                                        <td>
                                            <Tooltip title="View More Data">
                                                <OpenInNewIcon
                                                    style={{ fontSize: "20px", cursor: "pointer", marginLeft: "5px" }}
                                                    color="action"
                                                    onClick={() => {
                                                        this.setState({
                                                            showUserDetailModal: true,
                                                        });
                                                    }}
                                                />
                                            </Tooltip>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td style={{ verticalAlign: 'sub' }}>
                                            <Form.Label>Process</Form.Label>
                                        </td>
                                        <td
                                            style={{
                                                width: "70%",
                                            }}
                                        >
                                            <Select menuPlacement="auto"
                                                blurInputOnSelect={false}
                                                value={this.state.newProcess}
                                                isSearchable={true}
                                                name="Process"
                                                styles={Constants.Styles}
                                                menuPortalTarget={document.body}
                                                options={this.state.processOptions}
                                                onChange={(selectedOption) =>
                                                    this.setState({ newProcess: selectedOption })
                                                }
                                            />
                                            {this.props.sourceData[0].nextprocessid && (
                                                <div style={{ marginTop: '8px', color: '#6c757d', fontStyle: 'italic' }}>
                                                    Note: Next process should be <strong>{this.props.sourceData[0].nextprocessname}</strong>.
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.buttonDisable()}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
}
